import React, { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/toast.css';

const ModernToastContainer = () => {
  // Override toast methods to ensure autoClose is always set
  useEffect(() => {
    const originalSuccess = toast.success;
    const originalError = toast.error;
    const originalInfo = toast.info;
    const originalWarning = toast.warning;

    toast.success = (message, options = {}) => {
      return originalSuccess(message, { autoClose: 500, closeButton: false, ...options });
    };

    toast.error = (message, options = {}) => {
      return originalError(message, { autoClose: 500, closeButton: false, ...options });
    };

    toast.info = (message, options = {}) => {
      return originalInfo(message, { autoClose: 500, closeButton: false, ...options });
    };

    toast.warning = (message, options = {}) => {
      return originalWarning(message, { autoClose: 500, closeButton: false, ...options });
    };

    return () => {
      toast.success = originalSuccess;
      toast.error = originalError;
      toast.info = originalInfo;
      toast.warning = originalWarning;
    };
  }, []);

  return (
    <ToastContainer
      position="top-center"
      autoClose={500}
      hideProgressBar={false}
      newestOnTop={true}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss={false}
      draggable={false}
      pauseOnHover={false}
      theme="colored"
      limit={3}
      enableMultiContainer={false}
      closeButton={false}
      style={{
        zIndex: 9999,
      }}
    />
  );
};

export default ModernToastContainer;

